/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
export default function scrollBlock(selector1, selector2, stateBlock) {
  const block1 = document.querySelector(selector1);
  const block2 = document.querySelector(selector2);
  if (block1 && stateBlock) {
    block1.style.overflow = 'hidden';
    block2.style.overflow = 'hidden';
  }
  if (block1 && !stateBlock) {
    block1.style.overflow = 'scroll';
    block2.style.overflow = 'auto';
  }
}
